import React, { Component } from 'react'
import {Link} from 'react-router-dom'
class ServicesBoxs1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataEvents: [
                {
                    id: 1,
                    classicon: 'icon-rounded clipboard',
                    title: 'MERL Services',
                    description: 'Designing M&E strategic plans, frameworks, and conducting evaluations.', 
                },
                {
                    id: 2,
                    classicon: 'icon-rounded line-chart',
                    title: 'Data Analytics',
                    description: 'Statistical analysis, modeling, visualization and actionable insights.',
                },
                {
                    id: 3,
                    classicon: 'icon-rounded clock',
                    title: 'Capacity Building',
                    description: 'Tailored training in MERL and statistics for individuals and organizations.',
                },
            ]
        }
    }
    
    render() {
        return (
            <div className="row">
                {
                    this.state.dataEvents.map(data => (
                        <div className="col-lg-4 col-md-6 col-sm-12" key={data.id}>
                            <div className="iconbox-item" style={{ height: '100%' }}>
                                <div className="iconbox style1" style={{ background: '#ffffff', padding: '22px', height: '100%', textAlign: 'center', overflow: 'hidden' }}>
                                    <div className="box-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
                                        <div className={data.classicon} style={{ position: 'static', width: '44px', height: '44px', background: '#62B6E8', margin: '0', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
                                            {data.id === 1 && <i className="fa fa-clipboard" style={{ fontSize: '18px' }}></i>}
                                            {data.id === 2 && <i className="fa fa-line-chart" style={{ fontSize: '18px' }}></i>}
                                            {data.id === 3 && <i className="fa fa-clock-o" style={{ fontSize: '18px' }}></i>}
                                        </div>
                                        {/* <!-- /.icon-rounded --> */}
                                        <div className="box-title" style={{ marginTop: '6px', textAlign: 'left', flex: 1 }}>
                                            <Link to={`/services/${data.id}`} title="" style={{ fontWeight: 700 }}>{data.title}</Link>
                                        </div>
                                        {/* <!-- /.box-title --> */}
                                        </div>
                                    {/* <!-- /.box-header --> */}
                                    <div className="box-content" style={{ opacity: 0.9 }}>{data.description}</div>
                                    {/* <!-- /.box-content --> */}
                                </div>
                                 {/* <!-- /.iconbox --> */}
					    </div>
                            {/* <!-- /.iconbox-item --> */}
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ServicesBoxs1;
